var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "900" } },
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("edit-column")))]),
      _c(
        "app-detail-settings-edit-content",
        {
          attrs: {
            "selected-language": _vm.selectedLanguage,
            value: _vm.value,
            "model-name": "Bank",
          },
        },
        [
          _c(
            "w-row",
            { attrs: { slot: "before" }, slot: "before" },
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("app-custom-language-select", {
                    attrs: { value: _vm.selectedLanguage },
                    on: {
                      input: function ($event) {
                        return _vm.setSelectedLanguage($event)
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c("w-switch", {
            style: {
              flexShrink: 0,
              flexGrow: 0,
              width: "auto",
              paddingLeft: "5px",
            },
            attrs: {
              slot: "after",
              reverse: "",
              value: _vm.value.HeaderField != null,
              label: _vm.$ct("has-column-header"),
            },
            on: {
              input: function ($event) {
                return _vm.onToggleHasHeader($event)
              },
            },
            slot: "after",
          }),
        ],
        1
      ),
      _c(
        "transition",
        {
          on: {
            "before-leave": _vm.onDetailSettingsBeforeLeave,
            leave: _vm.onDetailSettingsLeave,
            enter: _vm.onDetailSettingsEnter,
            "after-enter": _vm.onDetailSettingsAfterEnter,
          },
        },
        [
          _vm.value.HeaderField
            ? _c("app-detail-settings-edit-content", {
                staticClass: "slide-height-transition",
                attrs: {
                  "selected-language": _vm.selectedLanguage,
                  value: _vm.value.HeaderField,
                  "is-header": "",
                  "model-name": "Sale",
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$t("common.cancel")) + " ")]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$ct("common.save")) + " ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }